import React, { useState, useEffect } from 'react';

function Timer({
  minutes, isFinished, setIsFinished, hidden, ...props
}) {
  const [min, setMin] = useState(minutes);
  const [sec, setSec] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (sec === 0) {
        setSec(59);
        setMin(min - 1);
      } else if (sec > 0) {
        setSec(sec - 1);
      }
      if (min === 0 && sec === 0) {
        setIsFinished(true);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [sec]); // eslint-disable-line react-hooks/exhaustive-deps

  if (hidden) {
    return null;
  }
  return (
    <>
      {min.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}
      :
      {sec.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}
    </>
  );
}

export default Timer;
